module.exports = __webpack_public_path__ + "static/media/getting-started.ce74f5c4.png";